import { render, staticRenderFns } from "./document-tags.vue?vue&type=template&id=74bb5240"
import script from "./document-tags.vue?vue&type=script&lang=ts"
export * from "./document-tags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports